import { z } from 'zod';

import { isRegistrationDateValid } from '../../validations/registration-date-validation';

import {
    REGION_FIELD,
    BIRTH_DATE_FIELD,
    POSTAL_CODE_FIELD,
    STREET_ADDRESS_FIELD,
    LOCALITY_FIELD,
    TAX_ID_FIELD,
} from './registration.constants';

export const registrationStepTwoSchema = (ageRequirements: { minimumAge: number }) =>
    z.object({
        [BIRTH_DATE_FIELD.name]: z
            .string()
            .min(2, { message: 'registration.step-one.birth-date.incorrect-date.error' })
            .refine((value) => isRegistrationDateValid(value, ageRequirements), {
                message: 'registration.step-one.birth-date.under-minimum-age.error',
            }),
        [TAX_ID_FIELD.name]: z
            .string()
            .min(4, { message: 'registration.step-one.tax-id.min-length.error' })
            .max(4, { message: 'registration.step-one.tax-id.max-length.error' })
            .regex(/^\d{4}$/, {
                message: 'registration.step-one.tax-id.invalid-characters.error',
            }),
        [STREET_ADDRESS_FIELD.name]: z
            .string()
            .min(2, { message: 'registration.step-one.street-address.min-length.error' })
            .max(120, { message: 'registration.step-one.street-address.max-length.error' })
            .regex(/^.+$/, {
                message: 'registration.step-one.street-address.invalid-characters.error',
            }),
        [LOCALITY_FIELD.name]: z
            .string()
            .min(2, { message: 'registration.step-one.locality.min-length.error' })
            .max(120, { message: 'registration.step-one.locality.max-length.error' })
            .regex(/^.+$/, {
                message: 'registration.step-one.locality.invalid-characters.error',
            }),
        [POSTAL_CODE_FIELD.name]: z
            .string()
            .min(5, { message: 'registration.step-one.postal-code.min-length.error' })
            .max(5, { message: 'registration.step-one.postal-code.max-length.error' })
            .regex(/^\d{5}$/, {
                message: 'registration.step-one.postal-code.invalid-characters.error',
            }),
        [REGION_FIELD.name]: z
            .string()
            .min(2, { message: 'registration.step-one.region.min-length.error' })
            .max(2, { message: 'registration.step-one.region.max-length.error' })
            .regex(/^[A-Z]{2}$/, {
                message: 'registration.step-one.postal-code.invalid-characters.error',
            }),
        // [ADDRESS_COUNTRY_FIELD.name]: z
        //     .string()
        //     .min(2, { message: 'registration.step-one.address-country.select-country.error' })
        //     .regex(/^US$/, {
        //         message: 'registration.step-one.address-country.invalid-characters.error',
        //     }),
    });
